import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PromotionUploadPage } from './promotion-upload.page';

const routes: Routes = [
  {
    path: '',
    component: PromotionUploadPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PromotionUploadPageRoutingModule {}
